import styled, { css } from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { TEMPLATE_PREVIEW_SIZE_VARIANTS } from '../constants';

const TEMPLATE_PREVIEW_CONTAINER_SIZE_STYLES = {
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.CARD]: css`
    height: ${pxToRem(200)};
  `,
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.THUMBNAIL]: css`
    height: ${pxToRem(50)};
  `,
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.SMALL_THUMBNAIL]: css`
    height: ${pxToRem(40)};
  `,
};

const iframeCommonStyles = css`
  border: none;
  pointer-events: none;
  position: absolute;
`;

export const ActionContainer = styled.section`
  padding: ${spacing.half} ${spacing.half} 0;
  background: ${colors.grey5};
`;

export const PreviewContainer = styled.section`
  align-items: center;
  background: ${colors.grey5};
  border-radius: ${spacing.quarter};
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${({ size }) => TEMPLATE_PREVIEW_CONTAINER_SIZE_STYLES[size] || ''}
`;

export const IframeContainer = styled.div`
  display: flex;
  height: ${pxToRem(175)};
  justify-content: center;
  position: relative;
  width: 100%;
`;

export const EmailIframe = styled.iframe`
  height: ${pxToRem(550)};
  transform: scale(0.35) translateY(-97.5%); /** need to translate due to scaling; */
  width: ${pxToRem(800)};
  background: white;
  ${iframeCommonStyles}
`;

export const WebPushIframe = styled.iframe`
  height: ${pxToRem(200)};
  transform: scale(0.85) translateY(20%); /** need to translate due to scaling */
  width: ${pxToRem(340)};
  ${iframeCommonStyles}
`;

export const MobileIframe = styled.iframe`
  height: ${pxToRem(460)};
  transform: scale(0.7) translate(16.75%, -20%); /** need to translate due to scaling */
  width: ${pxToRem(630)};
  ${iframeCommonStyles}
`;
